import { default_pods_input_state_smart_get, virtel_schema_smart_get } from "./ter-virtel-definition-lib";
import { _get_fixed_fields } from "./ter-virtel-utils";
import { _getParamsFromLib } from "./ter-params-utils";
import { js_utils } from "../utils/frfr-js-utils";
import { derAutoCreateVirbom_terkk_eliminatorkapi_children, derAutoCreateVirbom_terkk_eliminatorkapi_prepare_vir_input } from "./ter-derivat-lib-terkk-eliminatorkapi";
import { virbomCounter } from "../utils/frfr-virbom-counter-utils";
import { _virbom_manipulator } from "../utils/frfr-virbom-manipulator-utils";
import { _enrich_virtel_from_unbundled_subDraftel_arr_with_fresh_subkey } from "./ter-virbom-datarender";


// TER DRAFTEL CODECS LIB

/*
TODO: treba izmeniti definicije polja za eliminatorkapi

*/

/*
NOVO

- PITANJE: Da li je bundle_id potreban jos uvek??? Izgleda da jeste ukoliko je dozvoljeno imati vise bundlea istog tipa kao sibling. Ukoliko nije dozvoljeno onda ne...


STRUKTURA bundle elk:

// PODS_INPUT
msirinaunutrasnja: null,
mvisinaunutrasnja: null,

// SUPERFORM
tipeliminatorakapi (text)

// SUBFORM
sirina (number)
visina (number)
kolicina (number)

// OSTALO, META...
_draftelschemakey: terkk$_bundle_eliminatorkapi
terkknivo: CHILDOFMODUL
flag_custom_pods_input	false
subkey	1109
parent_subkey	430

verovatno je resenje imati superDraftel i subDraftel

*/


export const draftel_codecs_pack_terkk$_bundle_eliminatorkapi = {};


// ---------- CODEC SCHEMA METHODS ----------


draftel_codecs_pack_terkk$_bundle_eliminatorkapi._bundle_schema_get = () => {
  const bundle_schema = {
    _bundle_only: {
      _draftelschemakey: 'terkk$_bundle_eliminatorkapi',
      subkey: null,
      parent_subkey: null,
    },
    pods_input: {
      msirinaunutrasnja: null,
      mvisinaunutrasnja: null,
    },
    _bundle_combo: {
      // ovo su podaci koji zavisno od toga da li nastaje array ili piramida mogu biti prepisani u virtel ili bivaju napusteni u bundleu.
      terkknivo: 'CHILDOFMODUL', // ???
    },
    _superform: {
      flag_custom_pods_input: false, // flag_custom_pods_input is false by default
      tipeliminatorakapi: null,
    },
    _subform_item: {
      _draftelschemakey: 'terkk$_bundle_eliminatorkapi_subform_item',
      // tempkey: null,
      _sirina: null,
      visina: null,
      kolicina: null,
    },
  };
  return bundle_schema;
};


draftel_codecs_pack_terkk$_bundle_eliminatorkapi.default_preset_state = () => {
  const preset_state = {
    _draftelschemakey: 'terkk$_bundle_eliminatorkapi',
    terkknivo: 'CHILDOFMODUL', // ???
    // ID polje ne ide u preset, dobija se samo u EDIT MODE ali i tada mora biti obezbedjeno

    _subform_arr: [], // SUBFORM ARR

    "flag_custom_pods_input": false, // flag_custom_pods_input is false by default

    // pods_input za bundle nepotreban jer se koristi widget za pods_input
    // msirinaunutrasnja: null,
    // mvisinaunutrasnja: null,

    //
    tipeliminatorakapi: 'standardni',
    /*
    sirina1: null,
    visina1: null,
    brojkomada1: null,
    sirina2: null,
    visina2: null,
    brojkomada2: null,
    */
  };
  return preset_state;
};


draftel_codecs_pack_terkk$_bundle_eliminatorkapi.default_pods_input_state = () => {
  /*
  return {
    msirinaunutrasnja: null,
    mvisinaunutrasnja: null
  };
  */
  return default_pods_input_state_smart_get('terkk$eliminatorkapi');
};


/*
draftel_codecs_pack_terkk$eliminatorkapi.default_preset_state = () => {
  const preset_state = {
    _draftelschemakey: 'terkk$eliminatorkapi',
    terkknivo: 'CHILDOFMODUL', // ???
    // ID polje ne ide u preset, dobija se samo u EDIT MODE ali i tada mora biti obezbedjeno

    "flag_custom_pods_input": false, // flag_custom_pods_input is false by default

    bundle_id: null, // ???
    tipeliminatorakapi: 'standardni',
    sirina: null,
    visina: null,
    kolicina: null,
  };
  return preset_state;
};
*/


draftel_codecs_pack_terkk$_bundle_eliminatorkapi.default_subform_item_preset_state = () => {
  const preset_state = {
    _draftelschemakey: '_bundle_eliminatorkapi_subform_item',
    // terkknivo: 'CHILDOFMODUL', // ???
    // ID polje ne ide u preset, dobija se samo u EDIT MODE ali i tada mora biti obezbedjeno

    "flag_custom_pods_input": false, // flag_custom_pods_input is false by default

    // bundle_id: null, // ???

    // superform
    tipeliminatorakapi: 'standardni',

    // subform item
    sirina: null,
    visina: null,
    kolicina: null,
  };
  return preset_state;
};


draftel_codecs_pack_terkk$_bundle_eliminatorkapi.keys_for_direct_cloning = [
  "flag_custom_pods_input",

  // pods_input 
  // "msirinaunutrasnja",
  // "mvisinaunutrasnja",
  ...Object.keys(draftel_codecs_pack_terkk$_bundle_eliminatorkapi.default_pods_input_state()),

  "rev_id",
  "superkey",
  "subkey",
  "parent_subkey",
  // ...Object.keys(draftel_codecs_pack_terkk$eliminatorkapi.default_preset_state())
  ...Object.keys(draftel_codecs_pack_terkk$_bundle_eliminatorkapi.default_subform_item_preset_state()) // novo+++
];


// ---------- CODEC ENCODING  - DRAFTEL TO VIRBOM DIRECTION ----------


draftel_codecs_pack_terkk$_bundle_eliminatorkapi.subDrafel_to_virtel = (formState) => {
  // pretvara iz formState u virtel format sa ispravnim flagovima
  const sema = virtel_schema_smart_get('terkk$eliminatorkapi');
  console.log(formState);
  let state = {
    ...formState
  };
  const p = state;
  const eliminatorKapiNaziv = 'ELIMINATOR KAPI ' + p.sirina + ' x ' + p.visina;
  state.naziv = eliminatorKapiNaziv;
  //
  const state2 = {
    ...state,
    virtelschemakey: 'terkk$eliminatorkapi',
    ..._get_fixed_fields(sema),
    ..._getParamsFromLib("terkk$eliminatorkapi") // parametri na kraju imaju prioritet
  };
  return state2; // return virtel
};


//////////


draftel_codecs_pack_terkk$_bundle_eliminatorkapi.bundleDraftel_to_unbundled_subDraftel_arr = (bundleDraftel) => {
  // draftel single BUNDLE to draftel array
  const bundle = bundleDraftel;
  let _unbundled_subDraftel_arr = [];
  const zajednicki_higher_props_za_items = {
    // meta
    parent_subkey: bundle.parent_subkey,
    superkey: bundle.superkey,
    // bundle_id: p.bundle_id,
    // od poluproizvoda
    tipeliminatorakapi: bundle.tipeliminatorakapi,
    // pods_input TODO Da li treba bolje resenje?
    flag_custom_pods_input: bundle.flag_custom_pods_input,
    msirinaunutrasnja: bundle.msirinaunutrasnja,
    mvisinaunutrasnja: bundle.mvisinaunutrasnja,
    _extra_siframodula: bundle._extra_siframodula, // NOVO 2025-03-18
  };
  if (Array.isArray(bundle._subform_arr)) {
    bundle._subform_arr.forEach(elk_raw => {
      let draftel_elk = {
        // ...draftel_codecs_pack_terkk$eliminatorkapi.default_preset_state(),
        ...draftel_codecs_pack_terkk$_bundle_eliminatorkapi.default_subform_item_preset_state(),
        ...elk_raw,
        ...zajednicki_higher_props_za_items
      };
      _unbundled_subDraftel_arr.push(draftel_elk);
    });
  };
  return _unbundled_subDraftel_arr;
};


draftel_codecs_pack_terkk$_bundle_eliminatorkapi.bundleDrafel_to_virbom = (bundleDraftel) => {
  // MAIN CONVERT METHOD
  // const sema = virtel_schema_smart_get('terkk$_bundle_eliminatorkapi');

  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);

  // _bundle_eliminatorkapi (nema semu), ne salje se na backned, nema use_genus ni slicno... od njega ovde sad izracunavamo eliminatorkapi koji ce imati sve te parametre.
  // bundle_id sluzi da grupise nekoliko itema da idu zajedno
  // NOVO....POCETAK
  // rastavljamo bundle na pojedinacne p pomocu codec-a
  let eliminatorKapiArr = draftel_codecs_pack_terkk$_bundle_eliminatorkapi.bundleDraftel_to_unbundled_subDraftel_arr(bundleDraftel);
  console.log('eliminatorKapiArr spakovano sledece ');
  console.log(eliminatorKapiArr);
  // Sad prodjem kroz unbundleovani array i spakujem svaki kao ostale poluproizvode
  eliminatorKapiArr.forEach((p, index) => {
    // KORAK poluproizvod level 3 virtel
    // novonastali elementi raspakovani iz bundlea i oni jos uvek nemaju svoje ID-ove. Sada je potrebno da im dodelimo ID pomocu _enrichWithFreshSubkey()
    // graphlevel: 3,
    let virtel_elk = _enrich_virtel_from_unbundled_subDraftel_arr_with_fresh_subkey({
      ...draftel_codecs_pack_terkk$_bundle_eliminatorkapi.subDrafel_to_virtel(p),
      // virtelschemakey: 'terkk$eliminatorkapi',
    });
    // zatim preuzimamo taj novi ID da bi children elementi koji slede imali za parent_subkey.
    console.log(virtel_elk);
    const local_graphlevel = 1;
    // _virbom_manipulator.add_on_graphlevel(virbom_ref, virtel_demper, 3);
    _virbom_manipulator.add_on_graphlevel(virbom_ref, virtel_elk, local_graphlevel);

    // KORAK pripreme derivata za
    let pods_input_za_derivate = derAutoCreateVirbom_terkk_eliminatorkapi_prepare_vir_input(p);
    let _derivati = derAutoCreateVirbom_terkk_eliminatorkapi_children(pods_input_za_derivate);
    console.log('_derivati eliminatorkapi');
    console.log(_derivati);
    // USISAVANJE
    _virbom_manipulator._merge_virbom_into_virbom_on_graphlevel(virbom_ref, _derivati, local_graphlevel + 1, virbomCounter.generateFreshSubkey);

    // ***ZAVRSENI KORACI ZA JEDAN pp3

  }); // end of eliminatorKapiArr foreach

  // ZAVRSENI KORACI ZA JEDAN pp3

  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  return virbom_seq; // return virbom
};


// ---------- CODEC DECODING - VIRBOM TO DRAFTEL DIRECTION ----------


draftel_codecs_pack_terkk$_bundle_eliminatorkapi.virtel_to_subDraftel = (virtel) => {
  // pretvara iz virtela u formState format
  let state = {
    // ...draftel_codecs_pack_terkk$eliminatorkapi.default_preset_state(),
    ...draftel_codecs_pack_terkk$_bundle_eliminatorkapi.default_subform_item_preset_state(),
    ...js_utils.clone_obj_but_only_selected_keys(virtel, draftel_codecs_pack_terkk$_bundle_eliminatorkapi.keys_for_direct_cloning)
  };
  return state;
};


draftel_codecs_pack_terkk$_bundle_eliminatorkapi._virtelArr_to_bundleDraftel = (virtel_elk_arr, _generate_fresh_subkey, _generateFreshTempkey) => {
  // TO FORM
  // virtel elk arr to single draftel _bundle_eliminatorkapi
  // _bundle_eliminatorkapi ne treba bundle_id jer svi elk. od jednog projekta koji pripadaju jednom modulu su uvek jedan bundle. Dakle za bundlovanje se koristi parent_subkey (to je id parent modula).
  //
  console.log('CODEC MAKE BUNDLE _virtelArr_to_bundleDraftel() - virtel_elk_arr:');
  console.log(virtel_elk_arr);
  let parent_subkey_arr = [];
  virtel_elk_arr.forEach((item) => {
    if (parent_subkey_arr.includes(item.parent_subkey)) {
      // parent_subkey vec dodat
    } else {
      parent_subkey_arr.push(item.parent_subkey);
    }
  });
  //
  let bundle_arr = [];
  parent_subkey_arr.forEach((parent_subkey) => {
    // za svaki modul pravimo jedan _bundle_eliminatorkapi
    let _subform_arr = [];
    const bundle_id = _generate_fresh_subkey();
    virtel_elk_arr.forEach(virtel => {
      if (virtel.parent_subkey === parent_subkey) {
        const draftel_item = {
          ...draftel_codecs_pack_terkk$_bundle_eliminatorkapi.virtel_to_subDraftel(virtel),
          tempkey: _generateFreshTempkey(),
        };
        _subform_arr.push(draftel_item);
      }
    });
    if (js_utils.is_object(_subform_arr[0])) {
      const _first_item = _subform_arr[0];
      const zajednicki_higher_props_za_items = {
        parent_subkey,
        // superkey: bundle.superkey, // ???
        // bundle_id: p.bundle_id,
        subkey: bundle_id,
        // od poluproizvoda
        tipeliminatorakapi: _first_item.tipeliminatorakapi,
        // pods_input TODO Da li treba bolje resenje?
        flag_custom_pods_input: _first_item.flag_custom_pods_input,
        msirinaunutrasnja: _first_item.msirinaunutrasnja,
        mvisinaunutrasnja: _first_item.mvisinaunutrasnja,
      };
      let bundleDraftel = {
        // _draftelschemakey: 'terkk$_bundle_eliminatorkapi',
        ...draftel_codecs_pack_terkk$_bundle_eliminatorkapi.default_preset_state(),
        _subform_arr: _subform_arr,
        ...zajednicki_higher_props_za_items
      };
      bundle_arr.push(bundleDraftel);
    }
  });
  /*
  if (virtel_elk_arr.length === 1) {
    // ako je samo jedan elk
    let elk1 = virtel_elk_arr[0];
    let elk2 = {};
    let elk_bundle_sklopljeni = {
      // _draftelschemakey: 'terkk$_bundle_eliminatorkapi',
      ...draftel_codecs_pack_terkk$_bundle_eliminatorkapi.default_preset_state(),
      parent_subkey: elk1.parent_subkey,
      bundle_id: 1,
      sirina1: elk1.sirina,
      visina1: elk1.visina,
      brojkomada1: elk1.kolicina,
      sirina2: elk2.sirina,
      visina2: elk2.visina,
      brojkomada2: elk2.kolicina
    };
    bundle_arr.push(elk_bundle_sklopljeni);
  } else if (virtel_elk_arr.length > 1) {
    let bundle_id_arr = [];
    virtel_elk_arr.forEach((elk) => {
      if (bundle_id_arr.includes(elk.bundle_id)) {
        // bundle_id vec dodat
      } else {
        bundle_id_arr.push(elk.bundle_id);
      }
    });
    bundle_id_arr.forEach((bundle_id) => {
      let bundle = [];
      virtel_elk_arr.forEach((elk) => {
        if (elk.bundle_id === bundle_id) {
          bundle.push(elk);
        }
      });
      //
      let elk1 = bundle[0];
      let elk2 = {};
      if (bundle.length > 1) {
        elk2 = bundle[1];
      }
      let elk_bundle_sklopljeni = {
        // _draftelschemakey: 'terkk$_bundle_eliminatorkapi',
        ...draftel_codecs_pack_terkk$_bundle_eliminatorkapi.default_preset_state(),
        parent_subkey: elk1.parent_subkey,
        bundle_id: bundle_id,
        sirina1: elk1.sirina,
        visina1: elk1.visina,
        brojkomada1: elk1.kolicina,
        sirina2: elk2.sirina,
        visina2: elk2.visina,
        brojkomada2: elk2.kolicina
      };
      bundle_arr.push(elk_bundle_sklopljeni);
    });
  }
  */
  console.log('CODEC output BUNDLES bundle_arr');
  console.log(bundle_arr);
  return bundle_arr;
};

